/* ============================================================
   LIFTSHAPE CAMI — Size Finder (Rose on Six, DACH)
   ------------------------------------------------------------
   INTEGRATION CONTRACT

   1. TRIGGER   <a href="#" data-cf-open>Meine perfekte Größe finden</a>
      Delegated on `document` — survives Shopify variant re-renders.
      Do NOT bind directly to the link.

   2. EVENT (on document):  camifinder:result
        detail: { bucket, size, bra, tank }
        bucket: 'normal' | 'floor' | 'below' | 'beyond'
      Read the size from here, never the DOM.

   3. MODEL — two independent facts, do not conflate:
      Q1 = her BRA size (band+cup)      -> picks the table ROW
      Q2 = her TOP size (what she wears) -> picks the table COLUMN
      Both are facts about HER. Neither is relabelled on input.
      The lookup is TABLE[bra][topSize], read verbatim.
      ONLY the RESULT is relabelled to Rose on Six sizing:
        S->S M->M L->L XL->XL 1X->XXL 2X->3XL 3X->4XL
        XS -> below our range (we don't make it)
        4X -> beyond our range (cap at 4XL; incl. bra 95G)

   4. RESULT STATES
      normal : ROS size + "fällt größer aus" + one size down for shaping
      floor  : ROS size is S -> show S, NO size-down
      below  : honest dead-end, we don't carry her size
      beyond : cap at 4XL, honest ceiling note
      All except 'below' show the free-exchange line.

   5. This is a LOOKUP copied from the Honeylove Liftwear Cami and
      relabelled by MEASUREMENT (chest matches within ~0.3cm). Not a
      calculator. Do not edit the cells.
   ============================================================ */

(function () {
  'use strict';

  var CFG = Object.assign({ brand: 'Rose on Six', debug: false }, window.CF_CONFIG || {});

  var TABLE = {"65A":{"XS":"XS","S":"S"},"65B":{"XS":"XS","S":"S","M":"S"},"65C":{"XS":"XS","S":"S","M":"S"},"65D":{"XS":"XS","S":"S","M":"M"},"65E":{"XS":"XS","S":"S","M":"M"},"65F":{"XS":"S","S":"S","M":"M"},"65G":{"XS":"M","S":"M","M":"M","L":"L"},"70A":{"XS":"XS","S":"S","M":"M"},"70B":{"XS":"XS","S":"S","M":"M","L":"M"},"70C":{"XS":"S","S":"S","M":"M","L":"M"},"70D":{"XS":"S","S":"S","M":"M","L":"M"},"70E":{"XS":"S","S":"S","M":"M","L":"M"},"70F":{"XS":"S","S":"S","M":"M","L":"L"},"70G":{"XS":"M","S":"M","M":"M","L":"L","XL":"XL"},"75A":{"XS":"XS","S":"S","M":"M","L":"L","XL":"L"},"75B":{"XS":"S","S":"S","M":"M","L":"L","XL":"L"},"75C":{"XS":"S","S":"S","M":"M","L":"L","XL":"L"},"75D":{"XS":"S","S":"M","M":"M","L":"L","XL":"XL"},"75E":{"XS":"S","S":"M","M":"M","L":"L","XL":"XL"},"75F":{"XS":"S","S":"M","M":"L","L":"L","XL":"XL"},"75G":{"XS":"M","S":"L","M":"L","L":"L","XL":"XL","1X":"XL"},"80A":{"XS":"S","S":"S","M":"M","L":"L","XL":"XL","1X":"XL"},"80B":{"XS":"M","S":"M","M":"M","L":"L","XL":"XL"},"80C":{"S":"M","M":"L","L":"L","XL":"XL"},"80D":{"S":"M","M":"L","L":"L","XL":"XL","1X":"1X"},"80E":{"S":"L","M":"L","L":"XL","XL":"XL","1X":"1X"},"80F":{"M":"L","L":"L","XL":"XL","1X":"1X"},"80G":{"M":"L","L":"XL","XL":"XL","1X":"1X"},"85A":{"S":"M","M":"M","L":"L","XL":"XL","1X":"XL"},"85B":{"S":"M","M":"L","L":"L","XL":"XL","1X":"XL"},"85C":{"S":"L","M":"L","L":"XL","XL":"XL","1X":"1X"},"85D":{"S":"L","M":"L","L":"XL","XL":"XL","1X":"1X","2X":"2X"},"85E":{"M":"L","L":"XL","XL":"XL","1X":"1X","2X":"2X"},"85F":{"M":"L","L":"XL","XL":"1X","1X":"1X","2X":"2X"},"85G":{"M":"L","L":"XL","XL":"1X","1X":"1X","2X":"2X"},"90A":{"M":"L","L":"L","XL":"XL","1X":"XL","2X":"1X"},"90B":{"M":"L","L":"XL","XL":"XL","1X":"XL","2X":"1X","3X":"2X"},"90C":{"M":"XL","L":"XL","XL":"1X","1X":"1X","2X":"1X","3X":"2X"},"90D":{"M":"XL","L":"XL","XL":"1X","1X":"1X","2X":"1X","3X":"2X"},"90E":{"M":"XL","L":"XL","XL":"1X","1X":"1X","2X":"1X","3X":"2X"},"90F":{"M":"XL","L":"XL","XL":"1X","1X":"1X","2X":"1X","3X":"2X"},"90G":{"M":"XL","L":"1X","XL":"1X","1X":"2X","2X":"2X","3X":"3X"},"95A":{"L":"XL","XL":"XL","1X":"1X","2X":"1X","3X":"3X"},"95B":{"L":"XL","XL":"1X","1X":"1X","2X":"1X","3X":"3X"},"95C":{"L":"XL","XL":"1X","1X":"1X","2X":"1X","3X":"3X"},"95D":{"L":"XL","XL":"1X","1X":"1X","2X":"2X","3X":"3X"},"95E":{"L":"XL","XL":"1X","1X":"1X","2X":"2X","3X":"3X"},"95F":{"L":"1X","XL":"1X","1X":"1X","2X":"2X","3X":"3X"},"100A":{"L":"1X","XL":"1X","1X":"1X","2X":"1X","3X":"3X"},"100B":{"L":"1X","XL":"2X","1X":"2X","2X":"2X","3X":"3X"},"100C":{"L":"2X","XL":"2X","1X":"2X","2X":"2X","3X":"3X"},"100D":{"L":"2X","XL":"2X","1X":"2X","2X":"2X","3X":"3X"},"100E":{"XL":"2X","1X":"2X","2X":"3X","3X":"3X"},"100F":{"XL":"3X","1X":"3X","2X":"3X","3X":"3X"},"100G":{"XL":"2X","2X":"3X","3X":"3X"},"105A":{"1X":"2X","2X":"2X","3X":"3X"},"105B":{"XL":"2X","1X":"2X","2X":"3X","3X":"3X"},"105C":{"XL":"2X","1X":"2X","2X":"3X","3X":"3X"},"105D":{"XL":"2X","1X":"2X","2X":"3X","3X":"3X"},"105E":{"XL":"2X","1X":"2X","2X":"3X","3X":"3X"},"105F":{"1X":"2X","2X":"3X","3X":"3X"},"105G":{"2X":"3X","3X":"4X"},"110A":{"2X":"3X","3X":"3X"},"110B":{"1X":"2X","2X":"3X","3X":"3X"},"110C":{"XL":"3X","1X":"3X","2X":"3X","3X":"3X"},"110D":{"XL":"3X","1X":"3X","2X":"3X","3X":"3X"},"110E":{"1X":"2X","2X":"3X","3X":"4X"},"110F":{"1X":"2X","2X":"3X","3X":"4X"},"110G":{"2X":"3X","3X":"4X"},"95G":{"M":"4X","L":"4X","XL":"4X","1X":"4X","2X":"4X","3X":"4X"}};

  var BANDS = ['65','70','75','80','85','90','95','100','105','110'];
  var CUPS  = ['A','B','C','D','E','F','G'];

  /* top-size question: the table's own columns, in order. Shown to her
     verbatim — it's her existing top size, not ours to relabel. */
  var TOPS = ['XS','S','M','L','XL','1X','2X','3X'];

  /* result relabel: Honeylove size -> Rose on Six size / bucket */
  var RESULT = {
    'XS':'BELOW', 'S':'S','M':'M','L':'L','XL':'XL',
    '1X':'XXL','2X':'3XL','3X':'4XL','4X':'BEYOND'
  };
  var ORDER = ['S','M','L','XL','XXL','3XL','4XL'];
  /* shared scale for comparing her top-size input against the table result.
     Honeylove letters — both the Q2 columns and the raw table values live here. */
  var SCALE = ['XS','S','M','L','XL','1X','2X','3X','4X'];

  var T = {
    q1:'Welche BH-Größe trägst du?',
    q1hint:'Denk an den BH, der dir am besten passt',
    band:'Unterbrustweite', cup:'Cupgröße',
    q2:'Welche Größe trägst du bei eng anliegenden Tops?',
    q2hint:'Denk an ein Top, das gut sitzt',
    frage:'Frage', back:'Zurück', next:'Weiter', show:'Größe anzeigen', close:'Schließen',
    recTitle:'Deine empfohlene Größe für den LiftShape Cami:',
    entered:'BH <b>{bra}</b> · Top <b>{tank}</b>',
    biggerLine:'Der Cami fällt größer aus. Für strafferen Sitz empfehlen wir: <b>{s}</b>',
    exchange:'Kostenloser Umtausch — falls die Größe nicht perfekt sitzt.',
    beyondNote:'4XL ist unsere größte Größe.',
    belowTitle:'Leider keine passende Größe',
    belowMsg:'Für deine Größe haben wir leider noch kein passendes Cami. Unsere kleinste Größe ist S — die wäre dir voraussichtlich zu groß.',
    shop:'Jetzt shoppen', again:'Nochmal starten'
  };

  function esc(s){ return String(s).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function fill(s,m){ return String(s).replace(/\{(\w+)\}/g,function(_,k){ return m[k]!=null?m[k]:''; }); }

  /* Q2 options for a bra row: the columns that exist, verbatim labels */
  function optionsFor(bra){
    var row=TABLE[bra]; if(!row) return [];
    return TOPS.filter(function(t){ return row[t]!=null; });
  }

  /* lookup: bra row + her top size -> result state */
  function compute(bra, top){
    var row=TABLE[bra];
    if(!row || row[top]==null) return {bucket:'below'};
    var raw=row[top];                        // Honeylove result letter
    var mapped=RESULT[raw];
    if(mapped==='BELOW')  return {bucket:'below'};
    if(mapped==='BEYOND') return {bucket:'beyond', size:'4XL'};
    if(mapped==='S')      return {bucket:'floor', size:'S'};
    var i=ORDER.indexOf(mapped);
    var smaller = i>0 ? ORDER[i-1] : null;
    /* Double-drop guard: if the table ALREADY sized her down relative to the
       top size she entered (band contradicts an over-reported top size), she
       is already at the shaped end. Do NOT stack a further "size down for
       shaping" message on top. Suppress the smaller alternative. */
    var alreadyDown = SCALE.indexOf(raw) < SCALE.indexOf(top);
    if(alreadyDown) smaller=null;
    return {bucket:'normal', size:mapped, smaller:smaller};
  }

  /* ===================== UI ===================== */
  var overlay, modal, body, bar, state, step, lastFocus;
  function reset(){ state={band:'',cup:'',bra:'',top:''}; step=0; }
  function drawBar(){ bar.innerHTML='';
    for(var i=0;i<2;i++){ var d=document.createElement('div');
      d.className='ff-bar__seg'+((step>=2||i<=step)?' is-on':''); bar.appendChild(d); } }
  function nudge(){ var el=body.querySelector('.ff-opts,.ff-q1'); if(!el)return;
    el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge'); }
  function braReady(){ return !!(state.band && state.cup); }

  function pickPill(el,key){
    var grid=el.parentNode, sibs=grid.querySelectorAll('button');
    for(var i=0;i<sibs.length;i++){ sibs[i].classList.remove('is-on'); sibs[i].setAttribute('aria-pressed','false'); }
    el.classList.add('is-on'); el.setAttribute('aria-pressed','true');
    state[key]=el.getAttribute(key==='band'?'data-cf-band':'data-cf-cup');
    state.bra=state.band+state.cup;
    var cta=body.querySelector('[data-cf-next]');
    if(cta) cta.classList.toggle('is-ready', braReady() && !!TABLE[state.bra]);
  }

  function render(){ drawBar(); if(step>=2) return renderResult(); return step===0?renderQ1():renderQ2(); }

  function renderQ1(){
    var h='<div class="ff-step"><p class="ff-eyebrow">'+T.frage+' 1 / 2</p>';
    h+='<h2 class="ff-q" id="cfTitle">'+esc(T.q1)+'</h2><p class="ff-hint">'+esc(T.q1hint)+'</p>';
    h+='<div class="ff-q1"><p class="ff-lbl">'+T.band+'</p><div class="ff-grid ff-grid--band10" role="group" aria-label="'+T.band+'">';
    h+=BANDS.map(function(b){return '<button type="button" class="ff-pill'+(state.band===b?' is-on':'')+'" data-cf-band="'+b+'" aria-pressed="'+(state.band===b)+'">'+b+'</button>';}).join('');
    h+='</div><p class="ff-lbl">'+T.cup+'</p><div class="ff-grid ff-grid--cup7" role="group" aria-label="'+T.cup+'">';
    h+=CUPS.map(function(c){return '<button type="button" class="ff-pill'+(state.cup===c?' is-on':'')+'" data-cf-cup="'+c+'" aria-pressed="'+(state.cup===c)+'">'+c+'</button>';}).join('');
    h+='</div></div><div class="ff-nav"><button type="button" class="ff-back" data-cf-back hidden></button>';
    h+='<button type="button" class="ff-cta'+(braReady()&&TABLE[state.bra]?' is-ready':'')+'" data-cf-next>'+T.next+'</button></div></div>';
    body.innerHTML=h; var f=body.querySelector('.ff-pill'); if(f)f.focus();
  }

  function renderQ2(){
    var opts=optionsFor(state.bra);
    var h='<div class="ff-step"><p class="ff-eyebrow">'+T.frage+' 2 / 2</p>';
    h+='<h2 class="ff-q" id="cfTitle">'+esc(T.q2)+'</h2><p class="ff-hint">'+esc(T.q2hint)+'</p>';
    h+='<div class="ff-opts" role="group" aria-label="'+esc(T.q2)+'">';
    h+=opts.map(function(o){ var on=state.top===o;
      return '<button type="button" class="ff-opt'+(on?' is-on':'')+'" data-cf-top="'+o+'" aria-pressed="'+on+'">'+
        '<span class="ff-dot" aria-hidden="true"></span><span><span class="ff-opt__t">'+esc(o)+'</span></span></button>';
    }).join('');
    h+='</div><div class="ff-nav"><button type="button" class="ff-back" data-cf-back>&#8592; '+T.back+'</button>';
    h+='<button type="button" class="ff-cta'+(state.top?' is-ready':'')+'" data-cf-next>'+T.show+'</button></div></div>';
    body.innerHTML=h; var f=body.querySelector('.ff-opt'); if(f)f.focus();
  }

  function renderResult(){
    var r=compute(state.bra, state.top);
    var h='<div class="ff-step ff-result">';
    if(r.bucket==='below'){
      h+='<p class="ff-eyebrow" id="cfTitle">'+T.belowTitle+'</p>';
      h+='<div class="ff-note" style="margin-top:8px;text-align:left"><p>'+T.belowMsg+'</p></div>';
      h+='<div style="margin-top:24px"><button type="button" class="ff-again" data-cf-again>'+T.again+'</button></div></div>';
      body.innerHTML=h; dispatch(r); var a=body.querySelector('[data-cf-again]'); if(a)a.focus(); return;
    }
    h+='<p class="ff-eyebrow" id="cfTitle">'+T.recTitle+'</p>';
    h+='<div class="ff-tag"><p class="ff-tag__brand">'+esc(CFG.brand)+'</p><p class="ff-tag__size">'+esc(r.size)+'</p></div>';
    h+='<p class="ff-entered">'+fill(T.entered,{bra:esc(state.bra),tank:esc(state.top)})+'</p>';
    if(r.bucket==='normal' && r.smaller)
      h+='<div class="ff-note" style="margin-top:22px;text-align:left"><p>'+fill(T.biggerLine,{s:esc(r.smaller)})+'</p></div>';
    else if(r.bucket==='beyond')
      h+='<div class="ff-note" style="margin-top:22px;text-align:left"><p>'+T.beyondNote+'</p></div>';
    h+='<p class="ff-exchange">'+T.exchange+'</p>';
    h+='<button type="button" class="ff-cta ff-cta--full is-ready" data-cf-close style="margin-top:20px">'+T.shop+'</button>';
    h+='<div><button type="button" class="ff-again" data-cf-again>'+T.again+'</button></div></div>';
    body.innerHTML=h; dispatch(r); var c=body.querySelector('[data-cf-close]'); if(c)c.focus();
  }

  function dispatch(r){
    document.dispatchEvent(new CustomEvent('camifinder:result',{detail:{
      bucket:r.bucket, size:r.size||null, bra:state.bra, tank:state.top }}));
    if(CFG.debug) console.log('[cami-finder]', r, state);
  }

  function open(){ if(!overlay)return; lastFocus=document.activeElement; reset();
    overlay.hidden=false; overlay.classList.add('is-open'); document.documentElement.style.overflow='hidden'; render(); }
  function close(){ if(!overlay)return; overlay.classList.remove('is-open'); overlay.hidden=true;
    document.documentElement.style.overflow=''; if(lastFocus&&lastFocus.focus)lastFocus.focus(); }

  function init(){
    overlay=document.getElementById('cfOverlay'); if(!overlay)return;
    modal=document.getElementById('cfModal'); body=document.getElementById('cfBody'); bar=document.getElementById('cfBar'); reset();
    body.addEventListener('click',function(e){
      var b=e.target.closest('[data-cf-band]'); if(b){ pickPill(b,'band'); return; }
      var c=e.target.closest('[data-cf-cup]');  if(c){ pickPill(c,'cup'); return; }
      var t=e.target.closest('[data-cf-top]');
      if(t){ var g=t.parentNode.querySelectorAll('button');
        for(var i=0;i<g.length;i++){g[i].classList.remove('is-on');g[i].setAttribute('aria-pressed','false');}
        t.classList.add('is-on'); t.setAttribute('aria-pressed','true');
        state.top=t.getAttribute('data-cf-top');
        var cta=body.querySelector('[data-cf-next]'); if(cta)cta.classList.add('is-ready'); return; }
      if(e.target.closest('[data-cf-next]')){
        if(step===0){ if(!braReady()||!TABLE[state.bra]){ nudge(); return; } state.top=''; step=1; render(); return; }
        if(step===1){ if(!state.top){ nudge(); return; } step=2; render(); return; } }
      if(e.target.closest('[data-cf-back]')){ if(step>0){ step--; render(); } return; }
      if(e.target.closest('[data-cf-again]')){ reset(); render(); return; }
    });
    document.addEventListener('click',function(e){
      if(e.target.closest('[data-cf-open]')){ e.preventDefault(); open(); }
      if(e.target.closest('[data-cf-close]')){ close(); } });
    overlay.addEventListener('mousedown',function(e){ if(e.target===overlay) close(); });
    document.addEventListener('keydown',function(e){
      if(!overlay.classList.contains('is-open'))return;
      if(e.key==='Escape'){ close(); return; }
      if(e.key==='Tab'){ var f=modal.querySelectorAll('button:not([hidden])'); if(!f.length)return;
        var first=f[0],last=f[f.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();} } });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.CamiFinder={ open:open, close:close, compute:compute, optionsFor:optionsFor, table:TABLE, bands:BANDS, cups:CUPS, tops:TOPS };
})();
